import { EventEmitter } from "events";

export const animEventEmitter = new EventEmitter();